import { BlockList } from '@akademi/site-builder-runtime';
import type { BlockInstance } from '@akademi/site-builder-runtime';

/**
 * Renders the per-tenant {@code mediaTemplate.blocks} list of
 * {@link BlockInstance}s around a video / series / channel detail
 * surface. Thin wrapper over {@link BlockList} that themes can swap
 * for a richer template-aware renderer.
 */
export interface MediaTemplateBlocksProps {
  blocks?: BlockInstance[];
  themeId?: string | null;
}

export function MediaTemplateBlocks({ blocks, themeId }: MediaTemplateBlocksProps) {
  if (!blocks || blocks.length === 0) return null;
  return <BlockList items={blocks} themeId={themeId ?? null} />;
}
